import { render, staticRenderFns } from "./ClientBuyersList.vue?vue&type=template&id=3cb8fb7c&"
import script from "./ClientBuyersList.vue?vue&type=script&lang=ts&"
export * from "./ClientBuyersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports